import { combineReducers } from 'redux';
import app from './app';
import session from './session';

export default combineReducers({
  session,
  app,
});
